// =====================================================
// PARTICIPANT EXPORT UTILITY
// Export participants to CSV
// =====================================================

import type { ParticipantWithDetails } from '@/Services/eventParticipants.service';
import { csvFileName, downloadCsv } from './csv';

const PAYMENT_LABELS: Record<string, string> = {
  PAID: 'Pagado',
  PARTIAL: 'Parcial',
  PENDING: 'Pendiente',
  REVERSED: 'Revertido',
};
const REGISTRATION_LABELS: Record<string, string> = {
  PRE_REGISTERED: 'Por revisar',
  VERIFIED: 'Verificada',
  REJECTED: 'Rechazada',
};
const ATTENDANCE_LABELS: Record<string, string> = {
  ATTENDED: 'Asistió',
  ABSENT: 'Ausente',
  PENDING: 'Pendiente',
};

/**
 * Export participants to CSV file
 */
export function exportParticipantsToCSV(participants: ParticipantWithDetails[], eventName: string): void {
  const headers = [
    'Tipo',
    'Nombre',
    'Código ADB',
    'CI',
    'Distrito',
    'Región',
    'Cargo',
    'Email',
    'Teléfono',
    'Inscripción',
    'Origen',
    'Precio Calculado',
    'Regla Aplicada',
    'Estado de Pago',
    'Monto Pagado',
    'Asistencia',
    'Obligatorio',
    'Fecha de Registro',
  ];

  const rows = participants.map((p) => {
    const isMinister = !!p.minister_id;
    return [
      isMinister ? 'Ministro' : p.guest?.is_delegate ? 'Delegado' : 'Invitado',
      (isMinister ? p.minister?.full_name : p.guest?.full_name) || '',
      p.minister?.adb_code ?? '',
      (isMinister ? p.minister?.dni : p.guest?.dni) ?? '',
      p.minister?.district?.name ?? '',
      p.minister?.region?.name ?? '',
      p.authority_position ? `${p.authority_position} - ${p.authority_entity}` : '',
      p.guest?.email ?? '',
      p.guest?.phone ?? '',
      REGISTRATION_LABELS[p.registration_status] ?? p.registration_status,
      p.registration_source === 'PUBLIC' ? 'Formulario público' : 'Administración',
      p.calculated_price?.toFixed(2) ?? '0.00',
      p.pricing_rule?.name ?? 'Sin descuento',
      PAYMENT_LABELS[p.payment_status ?? ''] ?? '',
      p.payment_amount?.toFixed(2) ?? '',
      ATTENDANCE_LABELS[p.attendance_status ?? ''] ?? '',
      p.is_mandatory ? 'Sí' : 'No',
      new Date(p.registration_date).toLocaleDateString('es-BO'),
    ];
  });

  downloadCsv(csvFileName('participantes', eventName), headers, rows);
}
